export const NOT_STARTED = 'Not Started';
export const WORK_IN_PROGRESS = 'In Progress';
export const COMPLETE = 'Completed';
export const LOW_QUALITY = 'Low Quality';
export const GOOD_QUALITY = 'Good Quality';
export const HIGH_QUALITY = 'High Quality';
